import ApiService from './api.service'

const ExportService = {
  playerTemplate () {
    return ApiService.postWithoutLoading('api/v2/admin/export/playerTemplate')
  },
  clubTemplate () {
    return ApiService.postWithoutLoading('api/v2/admin/export/clubTemplate')
  },
  players () {
    return ApiService.postWithoutLoading('api/v1/admin/export/players')
  },
  clubs () {
    return ApiService.postWithoutLoading('api/v1/admin/export/clubs')
  },
  gamePdf (gameUuid) {
    return ApiService.postBlob('api/v2/admin/export/game/' + gameUuid + '/pdf')
  },
  gameDocx (gameUuid) {
    return ApiService.postBlob('api/v2/admin/export/game/' + gameUuid + '/docx')
  },
  gameXls (gameUuid) {
    return ApiService.postBlob('api/v2/admin/export/game/' + gameUuid + '/xlsx')
    // return axios({
    //   url: process.env.VUE_APP_BASE_URL + 'api/v2/admin/export/game/' + gameUuid + '/xlsx',
    //   method: 'POST',
    //   responseType: 'blob'
    // })
  },
  schedulePdf () {
    return ApiService.postBlob('api/v1/export/schedule')
  },
  leagueScheduleWord (schedule) {
    return ApiService.postBlob(`api/v1/export/schedule/${schedule}/docx`)
  },
  scheduleWord () {
    return ApiService.postBlob('api/v1/export/schedule/docx')
  },
  teamPlayersImagesDownload (schedule, team) {
    return ApiService.postBlob(`api/v1/admin/schedules/${schedule}/teams/${team}/download-player-images`)
  }
}

export default ExportService
